import { OrganizationManager } from "../organization-manager";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { CallCenterAlert } from "../call-center-alert";
import { CallCenterShiftTask } from "../call-center-shift-task";
import { CallCenterVolunteer } from "../call-center-volunteer";
import { CallCenterShiftEntityConfig } from "./config";
import { CallCenterShiftFilters } from "./filters";
import { CallCenterShiftMethods } from "./methods";

@HyperEntity<CallCenterShift>("call-center-shift", CallCenterShiftEntityConfig)
export class CallCenterShift extends extender(
  CallCenterShiftFilters,
  CallCenterShiftMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "volunteer_id", caption: "מתנדב" })
  volunteerId = "";

  @Relations.toOne(() => CallCenterVolunteer, "volunteerId")
  volunteer?: CallCenterVolunteer;

  @Fields.string({ dbName: "station_manager_id", caption: "מנהל עמדה" })
  stationManagerId = "";

  @Relations.toOne(() => OrganizationManager, "stationManagerId")
  stationManager?: OrganizationManager;

  @Relations.toMany(() => CallCenterShiftTask, "shiftId")
  tasks?: CallCenterShiftTask[];

  @Relations.toMany(() => CallCenterAlert, "shiftId")
  alerts?: CallCenterAlert[];

  @Fields.date({ dbName: "started_at", caption: "התחלה" })
  startedAt = new Date();

  @Fields.date({ dbName: "scheduled_end_at", caption: "סיום מתוכנן" })
  scheduledEndAt = new Date();

  @Fields.date({ dbName: "ended_at", allowNull: true, caption: "סיום" })
  endedAt?: Date | null;

  @Fields.integer({ dbName: "matches_count", caption: "מאצ'ים" })
  matchesCount = 0;

  @Fields.string({ dbName: "exit_feedback", allowNull: true, caption: "משוב יציאה" })
  exitFeedback?: string;

  @Fields.string({
    dbName: "thank_you_message",
    allowNull: true,
    caption: "הודעת תודה",
  })
  thankYouMessage?: string;

  @Fields.date({
    dbName: "briefing_seen_at",
    allowNull: true,
    caption: "דגשים נצפו",
  })
  briefingSeenAt?: Date;

  @Fields.date({ dbName: "goal_seen_at", allowNull: true, caption: "יעד נצפה" })
  goalSeenAt?: Date;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
